export enum StateEnum {
	IDLE = 'idle',
	PENDING = 'pending',
	REJECTED = 'rejected',
	RESOLVED = 'resolved'
}

/** @deprecated Use StateEnum instead */
export enum STATE_ENUM {
	idle = 'idle',
	pending = 'pending',
	rejected = 'rejected',
	resolved = 'resolved'
}
